import { render } from "./ModalAddParticipante.vue?vue&type=template&id=ba0fb194"
import script from "./ModalAddParticipante.vue?vue&type=script&lang=js"
export * from "./ModalAddParticipante.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__